<template>
   <div class="" v-if="campaign.customFacebookMessage == 'grade'">
        <div class="campaign-image" :style="{'background-image': `url('${uGreadePicture}')`}"></div>
    </div>
    <div class="" v-else>
        <div class="campaign-image" :style="{'background-image': `url('${uGreadePicture}')`}"></div>
    </div>
</template>
<script>

export default {
    name: "Picture",
    props: {
        campaign: { type: Object, required: true },
    },
    inject: ["AccountStore"],
    data: function() {
        return {
            uGrade: null,
            uGreadePicture: null,
        };
    },
    mounted: function() {
    },
    created: function () {
        if (this.campaign.customFacebookMessage == 'grade') {
            this.uGrade = this.AccountStore.state.userGrade
            this.setUGradePicture();
        } else {
            this.uGreadePicture = this.campaign.fullImageUrl
        }
    },
    methods: {
        setUGradePicture: function() {
            switch (this.uGrade) {
                case 'U':
                    this.uGreadePicture = this.campaign.fullImageUrl.replace("-large", "_U");
                    break;
                case 'E':
                    this.uGreadePicture = this.campaign.fullImageUrl.replace("-large", "_E");
                    break;
                case 'P':
                    this.uGreadePicture = this.campaign.fullImageUrl.replace("-large", "_P");
                    break;
                default:
                    this.uGreadePicture = this.campaign.fullImageUrl.replace("-large", "_Null");
                    break;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
  @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
